import { useTranslation } from '@crehana/i18n';
import { CANDIDATE_FORM, type TKeys } from '../i18n';

export const useTranslationCandidateForm = () => {
  const { t } = useTranslation<TKeys>(CANDIDATE_FORM);

  return {
    t,
  };
};
